import create from 'zustand'
import { persist } from 'zustand/middleware'

export const useLocaleStore = create(
  persist(
    set => ({
      locale: process.env.GATSBY_CURRENT_BUILD || 'de',
      setLocale: lang => {
        set(() => ({
          locale: process.env.GATSBY_CURRENT_BUILD
        }))
      }
    }),

    { name: 'locale-storage' }
  )
)
